import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4wf9xqwxhl: FaireBrandEntity = {
  token: "b_4wf9xqwxhl",
  type: "brand",
  name: "From Scratch Farm",
  avatarUrl:
    "https://cdn.faire.com/fastly/4f87cc978aabd89f879a4ec53185ab7e435272b99d7b04097dddc4ad829defee.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/87a8631fa7d3bce55d335a80da1a266b9ad2740c4e5aeecb073fad2ce111b024.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4f87cc978aabd89f879a4ec53185ab7e435272b99d7b04097dddc4ad829defee.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/87a8631fa7d3bce55d335a80da1a266b9ad2740c4e5aeecb073fad2ce111b024.jpeg",
  location: "Boerne, TX, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "I'm Amy Bierstedt, maker of my natural/non-toxic home, bath, and body product line: From Scratch Farm.\nItems that will care for your home, your health, your family, and our planet.  Never any dyes, perfumes, or chemicals.  Without plastic packaging, when I can.\nItems that are pampering, cleansing, sudsy, luxurious, moisturizing, and caring.\nGoods that I'm sure you and your customers are going to love!",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:59.199Z",
    importedBy: "entity-db-cli",
  },
};
